import { useStyle } from "@/context/StyleContext";
import React from "react";

const VerticalDivider = () => {
  const { colors, theme } = useStyle();
  return (
    <div
      style={{
        width: "1px",
        height: "100%",
        backgroundColor: colors[theme].divider,
        opacity: 0.1,
        margin: "0 10px",
      }}
    />
  );
};
export default VerticalDivider;
